/*=====================================
    NewProductsSideBarView

    Author: Ac
    CreateTime: 2018 / 10 / 25
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import BlockTopBar from 'components/commons/BlockTopBar';
import CupoyImage from 'components/commons/CupoyImage';
import GLOBAL from 'nonnglobal';
import productUtil, { PRODUCT_COVER_SIZE } from 'util/productUtil';

/*--------------------------
    Styled
--------------------------*/
const List = styled.ul`
    margin: 0;
`;
const ListItem = styled.li`
`;
const ListItemContent = styled.div`
    display: block;
    padding: 16px 16px 8px;
    cursor: pointer;
`;
const CoverWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: ${(225 / 300) * 100}%;
`;
const Cover = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #CCC;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;
const Text = styled.div`
    margin-top: 8px;
    font-size: 13px;
    color: ${Colors.Dark3};
    text-align: center;
`;
/*--------------------------
    Main Component
--------------------------*/
class NewProductsSideBarView extends PureComponent {

    componentDidMount() {

        const { isLoadedIdxPageInfo, isLoadingIdxPageInfo } = this.props;

        if(!isLoadedIdxPageInfo && !isLoadingIdxPageInfo)
            this.fetchIdxPageInfo();

    }

    fetchIdxPageInfo = () => {
        this.props.idxPageActions.getIdxPageInfo();
    }
    
    render() {

        const {
            newproducts = [],
        } = this.props;

        if(newproducts.length === 0) return null;

        return (
            <div>
                <GlobalStyle.BasicBlock>
                    <BlockTopBar title='新品上市' state={CupoyRouter.STATES.NEW_PRODUCTS} />
                    <List>
                        {newproducts.map((product, idx) => {

                            if(idx >= 4) return null;

                            const {
                                productname = '',
                                productid,
                                thumbimg,
                            } = product;

                            const imageSrc = productUtil.getProductCover(PRODUCT_COVER_SIZE.LARGE, productid, thumbimg);
                            const stateName = GLOBAL.getProductRouterName(product);

                            return (
                                <ListItem key={productid}>
                                    <CupoySrefView
                                        stylecomponent={ListItemContent}
                                        statename={stateName}
                                        params={{ id: productid }}
                                    >
                                        <CoverWrapper>
                                            <CupoyImage
                                                isBackgroundImage
                                                stylecomponent={Cover}
                                                src={imageSrc}
                                            />
                                        </CoverWrapper>
                                        <Text>{productname.trim()}</Text>
                                    </CupoySrefView>
                                </ListItem>
                            );
                        })}
                    </List>
                </GlobalStyle.BasicBlock>
            </div>
        );
    }
    
}
/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        newproducts: state.idxpage.newproducts,
        isLoadedIdxPageInfo: state.idxpage.isLoadedIdxPageInfo,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        idxPageActions: bindActionCreators(actionCreators.idxPageActionCreators, dispatch),
    };
};

/*--------------------------
    Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps)(NewProductsSideBarView);